import { useState, useEffect } from 'react';
import { APP_INFO, EMPTY, FINO_QUERY_REMITTER } from './../../../Utils/appConstants';
import { isNumber } from '../../../Utils/Common';
import { useHistory } from "react-router-dom"; // Use useHistory for v5
import PropagateLoader from "react-spinners/PropagateLoader";
import { postRequest } from '../../../Utils/AppApi';
import { toast } from 'react-toastify';
import { Button, Space, Table } from 'antd';
import { reactLocalStorage } from 'reactjs-localstorage';

const IndexComponent = (props) => {
    const history = useHistory(); // Use useHistory instead of useNavigate
    const [isLoading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [isCustomerService, setCustomerService] = useState(null);
    const [searchButton, setSearchButton] = useState(true);
    const [appData, setAppData] = useState(null);
    const [isSrpayAvailableLimit, setSrpayAvailableLimit] = useState(0);
    const [isDmt, setDmt] = useState(false);
    const [isDmt1, setDmt1] = useState(false);
    const [isDmt2, setDmt2] = useState(false);
    const [showCustomerForm, setShowCustomerForm] = useState(false);
    const [customerDetails, setCustomerDetails] = useState({
        customerMobile: "",
        customerName: "",
        pincode: ""
    });

    const appLocalData = reactLocalStorage.get(APP_INFO, EMPTY, true);

    useEffect(() => {
        if (appLocalData) {
            setAppData(JSON.parse(appLocalData));
        }
    }, [appLocalData]);

    const handleSearch = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length === 10) {
            setSearchButton(false);
        } else {
            setCustomerService(null);
            setSearchButton(true);
        }
        setDmt(false);
        setDmt1(false);
        setDmt2(false);
        setSearchText(value);
    };

    const getCustomerInfo = async () => {
        setDmt(false);
        setDmt1(false);
        setDmt2(false);
        setLoading(true);

        if (!searchText) {
            toast.error("Please enter a Customer Number", { autoClose: 3000 });
            setLoading(false);
            return;
        }
        if (searchText.length !== 10) {
            toast.error("Please enter a valid Mobile Number", { autoClose: 3000 });
            setLoading(false);
            return;
        }

        const payload = { customerMobile: searchText };

        try {
            const response = await postRequest(FINO_QUERY_REMITTER, payload, history); // Pass history
            if (response.success === true) {
                const customer = response.data;
                const apiCustomer = response.customerData?.data;

                console.log("Customer data:", customer);

                setSrpayAvailableLimit(customer?.availableLimit || 0);

                // Use API name if customerName is blank
                const finalName =
                    customer.customerName && customer.customerName.trim() !== ""
                        ? customer.customerName
                        : apiCustomer?.name || "";

                const finalPincode =
                    customer.pincode && customer.pincode.trim() !== ""
                        ? customer.pincode
                        : "";

                const isInvalidName = !finalName || /^\d+$/.test(finalName);
                const isInvalidPincode = !finalPincode || !/^\d{6}$/.test(finalPincode);

                if (isInvalidName || isInvalidPincode) {
                    setCustomerDetails({
                        customerMobile: customer.customerMobile,
                        customerName: finalName,
                        pincode: finalPincode
                    });

                    setShowCustomerForm(true);
                } else {
                    history.push({
                        pathname: "/money-transfer-fino",
                        state: {
                            customerData: {
                                ...customer,
                                customerName: finalName,
                                pincode: finalPincode
                            }
                        }
                    });
                }
            }


            else {
               if (response.code === 0 || response.response_code === 0) {

    if (response.data?.data?.url) {
        window.open(response.data.data.url, "_blank");
    }

} else if (response.formData && response.rejections) {

    // Check if URL exists inside the object
    if (response.rejections.url) {
        window.open(response.rejections.url, "_blank");
    }

    toast.warning("" + response.message, { autoClose: 3000 });
}
 else {
                    toast.error(response.message || "Unable to fetch customer info", { autoClose: 3000 });
                }
            }
        } catch (error) {
            console.error("Error fetching customer info:", error);
            toast.error(error.response?.data?.message || "Network error occurred", { autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitCustomer = async () => {
        if (!customerDetails.customerName.trim()) {
            toast.error("Customer name is required", { autoClose: 3000 });
            return;
        }
        if (/^\d+$/.test(customerDetails.customerName)) {
            toast.error("Customer name cannot be a mobile number", { autoClose: 3000 });
            return;
        }
        if (!customerDetails.pincode || !/^\d{6}$/.test(customerDetails.pincode)) {
            toast.error("Pincode must be exactly 6 digits", { autoClose: 3000 });
            return;
        }
        if (!customerDetails.customerMobile || !/^\d{10}$/.test(customerDetails.customerMobile)) {
            toast.error("Mobile number must be exactly 10 digits", { autoClose: 3000 });
            return;
        }

        try {
            const resp = await postRequest("/fino/update-customer-info", customerDetails, history);
            if (resp.success) {
                toast.success("Customer info updated successfully", { autoClose: 3000 });
                setShowCustomerForm(false);
                getCustomerInfo();
            } else {
                toast.error(resp.message || "Failed to update customer info", { autoClose: 3000 });
            }
        } catch (error) {
            console.error("Error updating customer info:", error);
            toast.error(error.response?.data?.message || "Network error occurred", { autoClose: 3000 });
        }
    };

    const columns = [
        {
            title: 'Service Name',
            dataIndex: 'serviceName',
            key: 'serviceName',
            render: (_, record) => (
                <>
                    <div className="text-danger">{record.serviceName}</div>
                    <sub className="text-semi-bold text-success">{record.detail}</sub>
                </>
            )
        },
        {
            title: 'Status',
            dataIndex: 'customerStatus',
            key: 'customerStatus',
            render: (_, record) => (
                <div className={record.customerStatus === "Registered" ? "text-success" : "text-danger"}>
                    {record.customerStatus}
                </div>
            )
        },
        {
            title: 'Service Status',
            dataIndex: 'serviceStatus',
            key: 'serviceStatus',
            render: (_, record) => (
                <div className={record.serviceStatus === "Available" ? "text-success" : "text-danger"}>
                    {record.serviceStatus}
                </div>
            )
        },
        {
            title: 'Provider Limit',
            key: 'remainingLimit',
            dataIndex: 'remainingLimit'
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        onClick={() => handleSubmit(record)}
                        disabled={record.serviceStatus !== "Available"}
                        className={record.serviceStatus === "Available" ? "btn bg-primary border-radius" : "btn bg-default"}
                    >
                        GO
                    </Button>
                </Space>
            ),
        },
    ];

    const data = Array.isArray(isCustomerService) ? isCustomerService : [];

    const handleSubmit = (data) => {
        if (data) {
            setCustomerService(null);
            switch (data.code) {
                case "DMT": setDmt(true); break;
                case "DMT1": setDmt1(true); break;
                case "DMT2": setDmt2(true); break;
                default: break;
            }
        }
    };

    if (isLoading) {
        return (
            <div className="content text-center" style={{ margin: "250px 0" }}>
                <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
            </div>
        );
    }

    return (
        <div>
            <div className='row mb-3'>
                <div className="input-group">
                    <div className="col-md-2"></div>
                    <div className="col-md-4">
                        <input
                            className="form-control py-2 border"
                            type="search"
                            value={searchText}
                            onKeyDown={isNumber}
                            placeholder='Enter Mobile Number'
                            maxLength={10}
                            onChange={(e) => handleSearch(e)}
                            aria-label="Customer mobile number"
                        />
                    </div>
                    <button
                        onClick={getCustomerInfo}
                        className="btn btn-primary ml-3 border-left-0 border"
                        disabled={searchButton}
                        type="button"
                    >
                        <i className="fa fa-search" /> Search
                    </button>
                </div>
            </div>

            {appData && isCustomerService && isCustomerService.length > 0 && appData.dmtTransactionLimit && (
                <div className="text-right mr-5 mb-1 text-default">
                    Available Limit Rs: <span className="blink_text text-danger">{isSrpayAvailableLimit}</span>
                </div>
            )}

            {isCustomerService && isCustomerService.length > 0 && (
                <>
                    <Table className="table" columns={columns} dataSource={data} size="small" />
                    <p className="text-center">एक महीने में आप सभी विकल्पों से केवल Rs. 25000 / Customer ही ट्रांसफर कर सकते हैं!</p>
                </>
            )}

            {showCustomerForm && (
                <div
                    className="modal"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1050
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '5px',
                            width: '400px',
                            boxShadow: '0 5px 15px rgba(0,0,0,.5)'
                        }}
                    >
                        <div className="input-group mb-3">
                            <h4>Complete Customer Details</h4>
                        </div>

                        <div className="input-group mb-3">
                            <input
                                className="form-control py-2 border"
                                type="text"
                                value={customerDetails.customerMobile}
                                disabled
                                style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
                                aria-label="Customer mobile number (disabled)"
                            />
                        </div>

                        <div className="input-group mb-3">
                            <input
                                className="form-control py-2 border"
                                type="text"
                                placeholder="Enter Customer Name"
                                value={customerDetails.customerName}
                                onChange={(e) => setCustomerDetails({ ...customerDetails, customerName: e.target.value })}
                                maxLength={40}
                                aria-label="Customer name"
                            />
                        </div>

                        <div className="input-group mb-3">
                            <input
                                className="form-control py-2 border"
                                type="text"
                                placeholder="Enter Pincode"
                                value={customerDetails.pincode}
                                maxLength={6}
                                onKeyDown={isNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value && !/^\d*$/.test(value)) {
                                        toast.error("Pincode must contain only digits", { autoClose: 3000 });
                                        return;
                                    }
                                    setCustomerDetails({ ...customerDetails, pincode: value });
                                }}
                                aria-label="Customer pincode"
                            />
                        </div>

                        <div className="input-group">
                            <Space size="middle">
                                <button
                                    onClick={handleSubmitCustomer}
                                    className="btn btn-primary border-left-0 border"
                                    type="button"
                                >
                                    Submit
                                </button>
                                <button
                                    onClick={() => setShowCustomerForm(false)}
                                    className="btn btn-danger border-left-0 border"
                                    type="button"
                                >
                                    Cancel
                                </button>
                            </Space>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default IndexComponent;